import { SectionLoader } from '@/shared/components/section-loader';

export const AdminMarkingLocationsListLoading = () => {
  return <SectionLoader />;
};
